import store from '../../store/index';
import railsAxios from '../railsAxios';
import redirectTo from './redirectTo';

const protectedRoutes = [
  '/v/pessoal',
  '/v/financeiro',
  '/loan_applications/loan_offers',
];

export default async function beforeEach(to, from, next) {
  store.dispatch('setAwaitingNavigation', true);
  try {
    const response = await railsAxios.get('/api/login-status');
    await store.dispatch('handleLoginCheck', response.data.data);

    if (protectedRoutes.includes(to.path) && !store.state.isLoggedIn) {
      redirectTo('/login', from.path);
      return;
    }

    if (store.state.isLoggedIn) {
      $('#mobile-nav--login-btn').text('Sair');
      $('#mobile-nav--login-btn').prop('href', '/logout');
      document.documentElement.scrollTop = 0;
      next();
    } else {
      next();
    }
  } catch (error) {
    store.dispatch('setBackendErrorMessage');
    next();
  }
}
